function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M168 262L44 390c-26 27-25 70 2 95 26 26 69 25 95-1l124-129 129 124c27 26 69 25 95-1 26-27 25-70-2-95L358 258l125-129c25-26 25-69-2-95-26-25-69-25-95 2L262 165 133 41c-27-26-69-25-95 1-26 27-25 70 2 95z"
}));